import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const Recommendations = ({
  title = "Featuring only the firms UK Marketers love to recommend",
  logos = [
    {
      url: "https://s3-alpha-sig.figma.com/img/50a2/dcbd/a2070d6349c87c7e79476919001c73a3?Expires=1747612800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=iMv1zfDe2kSWtSnvQjHs0D~LRAqMyvCYH~UerC9yAHXsxokePz1DZC7sYbVzHnYqvsIG~wRVSpiLRAmjJKYIeIO8008iGDnOLaYBn0hyhjY7jEeS06Xi7qnqGX7grUHUEWtHaepiaOLT2rFQ5FxTufpodSOpf3PNPShEnbx2yiWdT~r7UdmOJD9i1CaGVPwLyZTfyL29ydkOpf-mEiHrjBij~c4Wu9iFmVKd8LiJn6rRR124YJaahmeU9VY2~cMh9Tc7ZXyHJmoaPy8ZixCxZIvIzXV8k80WUZvACmfwMCtMWo9OptEL-KqnZMPODHEcXDdYDQs9zbT-uqBWhJAo~g__",
      width: 173,
      height: 24,
    },
    {
      url: "https://s3-alpha-sig.figma.com/img/ba7a/a4db/47b197121b75b57a2725ce1e7281da81?Expires=1747612800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=rOIfCBx5hNphE~Ig~CjcBQSLID2v5rKKHlPiDJ8rZ7kyFy3Vx9XqGnuNezZSWD~lfSouH9pUmv-p9MKHjeQO5p3Zokz2EPLrepldnGmlJpl~9B8zNrxWUA5ORQgH-bJeItFJxX5YCuMrimq9jiOsWxsccwirtSRM99sqAG8lDQDuQvMu8l1xuXBZr51P8YYT~IDV3WJ41oq1FVFkCfT8niFiS1TC5VwA6ZHrGH4z~y~~xldT45~ShXXXc3-mcquxd5duMhlHNWn07Wnu-Tkk-iJVnRvsImZ2G-JGnRYbKfISBi4DDza2HRNnWH1GHgpzIKzWjt4up9wOmPazSQR13w__",
      width: 116,
      height: 30,
    },
    {
      url: "https://s3-alpha-sig.figma.com/img/b830/d8d7/32069b4b350672c22a71b66e8315323a?Expires=1747612800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=fqMd0czqa7OmPSXMAhYJLWJAHoMPfOLpXpOGjBCfgdmOPN1bzqM0W8w3ZznfxFeIctSKrTxxOGt7lDtMICijDgeV08CaPz3uzl5e4nqFs~TD8yGSYqlXO5vaALJlmN1WPFtAUcpPmYBrijcdUwZSDgtMFe9serUKfkKjRlfQtR-drYa7lMnsLX9rpecVwANcoruGN2J7~CVm4Q-JmX9Nx-qVO7aoRg3rTGocEEAgtf7c0sLY9Ys7Qhpo9HUKjeG8SB4xQ36voaPtexAp-LfrIjoaN5m6KWUgma3CY3BKpZIQKEZkIa1AciwTvNoQbRdpN~3~PQRtIGmn305t1TeovA__",
      width: 74,
      height: 32,
    },
    {
      url: "https://s3-alpha-sig.figma.com/img/e2bb/55ae/8968061d1cff3faee39a7e258a17a470?Expires=1747612800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=GVkNMqxLV6s3Qx~cZrGWh9mgHl-vfdj5BhUaf0LvQR8OP7fBhGX40401866IEHGcUl5KBGdkkTB-L6ii00UoLCnnxY6pRQp2d25odxqYcpg~1xcC3OjrYOC9kZCEBzux1Z7NqrTxGgJZcOrVUXSOVJzjBFHzGvRId0oTHTEhXiHdh7mZAeGQmWWx-PkloBCp3gC6b-m3tNKU9IqeG0Z3TvHBRajyHqizJJnJbqAB7j3-3c2GA6CVIwLX3FKiV-hSiuwxoJUerjKqXcjcWlCdro2ElXz6pxFazGkL~9pLGWeTylIUeCUnXMy97E-7ViWELnHrj3j3IJTiXXHHC0NzJQ__",
      width: 119,
      height: 32,
    },
    {
      url: "https://s3-alpha-sig.figma.com/img/f293/c1fe/bc09661dc484fc7050506bb9c90d7d89?Expires=1747612800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=VDRqFToowen5nJnB-dpwwjI4XieNz8wmhf1HmyNA3mGi3klzQy4kkLPKtQvtFGuRzas1Y1glMW2860G-FjUvqF4esSp8hjeQgrBh~VRsZQ-lVNuZdP83wqZVy2G-jOI-IwrPEtcw-lVyVuMJlWOmR36Mk~3DC5WcZWgcljspohnCmOuJkicKxZv9FP5X2a6xpYTQq21kfrUm~9CRX5Y8c7Sdxn2RtTdXueiwLEzaAwqEz9YU~OJVhYwgpHmQclO~pQaPaFf7yQd7YklNokajkNrMt4~JAkF2DWQL1RPyUFo2KIn5vYPiDgp6QtbsHdpwj6jAshth6QOjNe2tJPAbsw__",
      width: 179,
      height: 22,
    },
    {
      url: "https://s3-alpha-sig.figma.com/img/d55c/3619/845dd02be89800e59c89d6fac5c180af?Expires=1747612800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=Xbxt~07y0H6UJ42rFh5V8Z-658K7KJ1tGuCfePYksgX9k3tFwuRWeEmfCsdtIEC-0EcN9ZD-ddeGtPiM4v28yU9Ibr1Vx6Cu6pBM26uoLkpfrCW2aUtKXLhkDJ-qz79VS5IA35mZXHu~kKq79EC~aoRh4cyxIdykn2tFxsBwZz91~kz8N~cEM0e035m5WSEA9WsF49dNwXrT9y5EHA8BFp80TZnvEWe3itIff6oXweGbBvkX9GY4VzUGvB5xSAZVcKmBSXSHZMwZdU6uSIC2DuSGQnguGj2usViI4CZK9uoIIlWZy5miDknAc5zAVMOZjEA0fDzreA3bnFWftyE3ZQ__",
      width: 77,
      height: 24,
    },
    {
      url: "https://s3-alpha-sig.figma.com/img/a6b8/acc9/e699c014fdd6ce7fe39c5310d88c4981?Expires=1747612800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=ZHDU20MxvsgU0k7IOsRRVHlkJCiwApCbYjkOXhKFMtMS5wAYU5O1XfRm5l7U~JPRuauk0MKQjvWoamVHtjFjdh0B7pYB5Mwe1ETEwsfZHmWV7IXasOoniWHClm-8SA8ofZkRev1PVQ2aRhTbnNRLj3LOR664h6uOz7WgBklk1CwoH3qE22g3VCvUavodGoj2qmxBCdleQEUuqwEmC5j9YRtr-5VvmFUprUEd1hrNu76u5ld~oQu0mFHz7~Fa72Ys7DGOlA4c3uIxeD7O-3DCmkAF3UlrSVg2r-pw3DHOEcpMZfrUD08DYSaiG5Cof~P~ibdswJjtyOIK5HOjYsKmfg__",
      width: 64,
      height: 24,
    },
    {
      url: "https://s3-alpha-sig.figma.com/img/4570/f19c/3b41d78af9fd503522d1db2e4b581d70?Expires=1747612800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=FTXXbkhzxJTB1bqwtCB7puCYFcDk-9oZdzLq3wkXbvPHOz2OO6Oz5pPoqSw4fLTBMOfEFKCGukgvxKdkk-bSG~9webiHkrAtwqSLb5uD94Jp6uUsH2Ut6LMbxDs4Xsq-49p32FotYoM3TpG2Q5rNKuFnnebHo-eMYBz30DVj3fKZyMC7KsZWTsRLmF-R4OvD2VPoSrGpvYyXwR0nE71JdzYk0dLsvlBbjeu3PnRfhZoLRbIphHdnv6pQdvnRxuwiO7FNlo7fuDqf6BPjjEGSl07Gxg0sjt2kvIZZbXjDOj4b~b-LlenrtBZPpg15Iy0cjb~PCgqE0TTVuwS63b9A5A__",
      width: 99,
      height: 24,
    },
  ],
  speed = 30,
}) => {
  // Duplicate logos array to create seamless loop
  const duplicatedLogos = [...logos, ...logos];

  return (
    <Container>
      <TitleWrapper>
        <Title>{title}</Title>
      </TitleWrapper>
      <MarqueeWrapper>
        <MarqueeContent speed={speed}>
          {duplicatedLogos.map((logo, index) => (
            <LogoWrapper key={index}>
              <Logo
                style={{
                  backgroundImage: `url(${logo.url})`,
                  width: `${logo.width}px`,
                  height: `${logo.height}px`,
                }}
              />
            </LogoWrapper>
          ))}
        </MarqueeContent>
      </MarqueeWrapper>
      <GradientOverlay left />
      <GradientOverlay right />
    </Container>
  );
};

const marqueeAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  position: relative;
  padding: 32px 0;
  overflow: hidden;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
`;

const Title = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  max-width: 1200px;
`;

const MarqueeWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const MarqueeContent = styled.div`
  display: flex;
  gap: 48px;
  animation: ${marqueeAnimation} ${(props) => props.speed}s linear infinite;
  white-space: nowrap;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  flex-shrink: 0;
`;

const GradientOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 70px;
  pointer-events: none;
  background: ${(props) =>
    props.left
      ? "linear-gradient(90deg, rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0) 100%)"
      : "linear-gradient(-90deg, rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0) 100%)"};
  ${(props) => (props.left ? "left: 0;" : "right: 0;")}
  z-index: 1;
`;

export default Recommendations;
